import './CityRow.css';
import { MiniProgressBar } from '../../components/MiniProgressBar';
import { Portrait } from '../../components/Portrait';
import { UfTile } from '../../components/UfTile';
import { t } from '../../copy/strings';
import { fmtPct, fmtVoters } from '../../format/numbers';
import { fmtHourShort } from '../../format/time';
import { type CityRow as CityData, leaderOf, rowStatus } from '../../model/abroad';
import type { Candidate } from '../../model/types';
import { openPlace } from '../../state/actions';
import { partyClass, partyOf } from '../../theme/parties';
import { statusText } from './CountryRow';

export interface CityRowProps {
  row: CityData;
  pair: readonly [Candidate, Candidate] | null;
  photos: boolean;
}

/**
 * Linha de cidade do exterior (§8.5 CityRow): a grade da `CountryRow`, com o ladrilho cinza do país, o nome da cidade,
 * "fechou às {hora}" ou "fecha às {hora}" e o eleitorado, à direita o retrato e o % do líder ou a situação. Abre a
 * cidade.
 */
export function CityRow({ row, pair, photos }: CityRowProps) {
  const { city } = row;
  const lead = pair ? leaderOf(row.shares) : null;
  const leader = lead === null || !pair ? null : pair[lead];
  const h = fmtHourShort(city.closes_t_min);
  const E = fmtVoters(city.electorate_ref);
  const status = rowStatus(row.sectionsFraction, row.closed);
  const aria =
    leader && row.shares && lead !== null
      ? t(row.closed ? 'city.row.aria' : 'city.row.aria.open', {
          CIDADE: city.name,
          X: leader.display_name,
          pX: fmtPct(row.shares[lead]),
          h,
        })
      : t('city.row.aria.status', { CIDADE: city.name, STATUS: statusText(status, null) });
  return (
    <button
      type="button"
      class="country-row city-row"
      data-testid="city-row"
      data-tse={city.tse}
      aria-label={aria}
      onClick={() => openPlace({ kind: 'abroad_city', iso2: city.country_iso2, tse: city.tse })}
    >
      <UfTile code={city.country_iso2} fill="plain" size="row" />
      <span class="country-row__text">
        <span class="country-row__name">{city.name}</span>
        <span class="country-row__sub">{t(row.closed ? 'city.row.sub' : 'city.row.sub.open', { h, E })}</span>
      </span>
      {leader && row.shares && lead !== null ? (
        <span class={`country-row__value ${partyClass(partyOf(leader))}`}>
          <Portrait candidate={leader} photo={photos ? leader.photo : null} size={22} />
          <span class="country-row__pct">{fmtPct(row.shares[lead])}</span>
        </span>
      ) : (
        <span class="country-row__status">{statusText(status, null)}</span>
      )}
      <span class="country-row__bar">
        <MiniProgressBar sectionsFraction={row.sectionsFraction} variant="thin" />
      </span>
    </button>
  );
}
